<template>
	<article ref="animationWrapper" :class="['color-mode-breakpoint', 'dark', 'key-numbers', 'animation-wrapper', { active: animate }]">
		<img src="@/assets/img/to-animate/T-Bane-Single.svg" class="t-bane" />
		<div class="row full-width small-up-1 medium-up-3">
			<div class="column top-title full-width small-half">
				<h2 v-html="data.title_key_numbers"></h2>
				<h3 v-html="data.year"></h3>
			</div>
			<div class="column track small-half">
				<img src="@/assets/img/to-animate/Track.svg" />
				<router-link 
					:to="this.data.key_numbers_page.path" 
					:href="this.data.key_numbers_page.url" 
					class="block-link" 
					v-text="data.key_numbers_page.title" 
					aria-role="button" 
					tabindex="0">
				</router-link>
			</div>
			<div class="column person-wrapper">
				<img src="@/assets/img/to-animate/Person.svg" />
				<p v-html="statTrips"></p>
			</div>
			<div class="column boat-wrapper">
				<boat class="boat"></boat>
				<p v-html="statKms"></p>
			</div>
		</div>
	</article>
</template>

<script>
import BaseAnimateableBlock from '../concept-page/BaseAnimateableBlock'
export default {
	extends: BaseAnimateableBlock,
	props: ['data'],
	computed: {
		statKms() {
			return this.$options.filters.boldNumbers(this.data.stat_km)
		},
		statTrips() {
			return this.$options.filters.boldNumbers(this.data.stat_trips)
		}
	},
	methods: {
		getHeaderTopOffset() {
			return this.headerLinkOffset;
		}
	},
	components: {
		Boat: () => import('../concept-page/svgs/Boat')
	}
}
</script>